export enum AccountAddressTypeEnum {
  TYPE_LEGAL = 'LEGAL',
  TYPE_ACTUAL = 'ACTUAL',
}

export interface AccountAddressResponse {
  city: string;
  cityId: string;
  street: string;
  streetId: string;
  house: string;
  houseType: string;
  room: string;
  regionCode: string;
  regionName: string;
  settlement: string;
  settlementId: string;
  area: string;
  areaId: string;
  postalCode: string;
  type: AccountAddressTypeEnum;
  country: string;
  flatType: string;
  flat: string;
  block: string;
  blockType: string;
}
